// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareListModalStyles } from "@eisinc/Overrides/Components/ShareListModal";
import { modalButtonsActionStyles } from "@eisinc/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

shareListModalStyles.modal = { size: 600 };

shareListModalStyles.container = {
    gap: 20,
    css: css`
        margin-top: 5px;
    `,
};

shareListModalStyles.shareListTooltip = {
    cssOverrides: {
        tooltipContainer: css`
            width: 500px;
            margin-left: -400px;
            &::after {
                left: 400px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 290px;
                            margin-left: -270px;
                            &::after {
                                left: 270px;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
        tooltipBody: css`
            padding: 5px;
        `,
    },
    typographyProps: {
        lineHeight: "16px",
    },
};

shareListModalStyles.shareByEmailTooltip = {};

shareListModalStyles.shareByBillingTooltip = {};

shareListModalStyles.recipientEmailTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 5px;
        `,
        tooltipContainer: css`
            margin-left: -150px;
            &::after {
                left: 150px;
            }
        `,
    },
    typographyProps: {
        weight: "normal",
    },
};

shareListModalStyles.cancelButtonGridItem = {};

shareListModalStyles.sendButtonGridItem = {};

shareListModalStyles.modalActions = {
    css: css`
        ${modalButtonsActionStyles.buttonsGridItem?.css}
    `,
};

shareListModalStyles.cancelButton = { ...modalButtonsActionStyles.cancelButton };

shareListModalStyles.sendButton = { ...modalButtonsActionStyles.submitButton };
